import { connect } from 'react-redux';
import { setIsNavDrawerOpen } from '../navigationSlice';
import TopBar from './TopBar';

const mapState = () => ({});

const mapDispatch = {
  setIsNavDrawerOpen,
};

export default connect(mapState, mapDispatch)(TopBar);
